import { useEffect, useState } from 'react';

// Service
import InternalVoucherService from '../../services/InternalVoucherService';
import { cashTypesFormat } from '../../models/CashRegisterMovementEntity';
import useQueryString from '../queryString/useQueryString';

//Hooks
import useUser from "../user/useUser";

const initialState = {
    items: [],
    totalResults: 0,
    totalPage: 1,
    filters: {
        cashRegisterId: '',
        from: '',
        to: '',
        pageSize: 10,
        pageNumber: 1,
    }
}

const useInternalVouchers = () => {
    const { branch } = useUser();
    const [internalVouchersState, setInternalVouchersState] = useState(initialState);
    const [loading, setLoading] = useState(false);
    const { filters, search, setParameterSearch, clearFilters } = useQueryString({ ...initialState.filters });

    const mapInternalVouchers = (items) => {
        return items && items.map(i => ({
            ...i,
            cashTypeOrigin: cashTypesFormat[i.cashTypeOrigin] || i.cashTypeOrigin,
            cashTypeDestination: cashTypesFormat[i.cashTypeDestination] || i.cashTypeDestination,
            cashType: cashTypesFormat[i.cashType] || i.cashType,
        }));
    }

    useEffect(() => {
        const SearchInternalVouchers = async () => {
            setLoading(true);
            await InternalVoucherService
                .SearchInternalVouchers(filters?.pageSize, filters?.pageNumber, filters, branch.id)
                .then(res =>
                    setInternalVouchersState({
                        ...internalVouchersState,
                        items: mapInternalVouchers(res.values),
                        totalResults: res.totalResults,
                        totalPage: res.totalPage
                    }))
                .finally(() => setLoading(false));
        }

        if (filters !== undefined && (!filters.cashRegisterId || filters.cashRegisterId > 0) && (branch?.id && branch?.id !== 0))
            SearchInternalVouchers();
    }, [filters, branch?.id]) // eslint-disable-line react-hooks/exhaustive-deps

    return {
        internalVouchers: internalVouchersState.items,
        loading,
        totalResults: internalVouchersState.totalResults,
        totalPage: internalVouchersState.totalPage,
        filters,
        search,
        setParameterSearch,
        clearFilters
    }
}

export default useInternalVouchers;